export default __webpack_public_path__ + "static/media/icon_pinterest.7d2abec1.svg";